export class ScrollHandler {
    constructor(element) {
        this.el = element;
        this.start = "trackpadtouchstart";
        this.move = "axismove";
        this.end = "trackpadtouchend";
        this.isScrolling = false;
        this.x = -10;
        this.y = -10;
        this.axis = [0, 0];
        this.emittedEventDetail = {
            detail: {
                axis: this.axis,
            },
        };

        this.onStart = this.onStart.bind(this);
        this.onMove = this.onMove.bind(this);
        this.onEnd = this.onEnd.bind(this);
    }

    addEventListeners() {
        this.el.addEventListener(this.start, this.onStart);
        this.el.addEventListener(this.move, this.onMove);
        this.el.addEventListener(this.end, this.onEnd);
    }

    removeEventListeners() {
        this.el.removeEventListener(this.start, this.onStart);
        this.el.removeEventListener(this.move, this.onMove);
        this.el.removeEventListener(this.end, this.onEnd);
    }

    onStart() {
        this.isScrolling = true;
    }

    onMove(event) {
        if (!this.isScrolling) return;

        const newX = event.detail.axis[0];
        const newY = event.detail.axis[1];

        if (this.x === -10) {
            this.x = newX;
            this.y = newY;
            return;
        }

        this.axis[0] = 8 * (newX - this.x);
        this.axis[1] = 8 * (newY - this.y);
        this.emittedEventDetail.axis = this.axis;
        event.target.emit("scroll", this.emittedEventDetail);

        this.x = newX;
        this.y = newY;
    }

    onEnd() {
        this.isScrolling = false;
        this.x = -10;
        this.y = -10;
    }
}
